<template>
  <div class="app flex-row align-items-center bg-black">
    <div class="container-fluid">
      <b-row class="justify-content-center scan-box">
        <b-col sm="10" lg="8">
          <div class="text-center">
              <img class="mb-20 logo-scan" :src="`/logo2.svg`">
              <div class="font-bold color-white">Welcome to PARADIGM Fitness, 
                <br>Scan your QR Code here to enter the gym</div>
              <div class="color-white">{{ realtime }}</div>
          </div>
          <div class="color-white">
            <div class="row justify-content-center">
              <div class="col-sm-12 col-lg-4 mb-50">
                <div>
                  <qrcode-reader :camera="cameraOn" :paused="false" :class="['qr-scanner mt-20 mb-20', cameraOn ? '' : 'hidden']" @decode="onDecode"></qrcode-reader>
                </div>
                <template v-if="scanDone === true">
                  <div class="box-scan-success mt-20">
                    <i :class="iconMessage"></i>
                    <div>{{messageScan}}</div>
                  </div>
                </template>
                <template v-else>
                  <div class="text-center">
                    <button @click="activeCamera" :class="['btn-primary mt-20', cameraOn ? 'hidden' : '']" >Scan QR Code</button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import { QrcodeReader } from 'vue-qrcode-reader'

export default {
  name: 'Scan',
  components: {
    'qrcode-reader': QrcodeReader
  },
  data: () => ({
    iconMessage: '',
    messageScan: '',
    cameraOn: false,
    scanDone: false,
    realtime: '',
    loginData: {
      email: '',
      password: ''
    }
  }),
  methods: {
    activeCamera () {
      this.cameraOn = true
      setTimeout(()=>{
        this.$nextTick(() =>{
          this.cameraOn = false
        })
      }, 6000);
    },
    realTimeClock () {
      // moment.locale('en')
      // // var self = this
      // var self = this
      // this.realtime = moment().format('MMMM Do YYYY, h:mm:ss a')
      // setInterval(self.realTimeClock, 1000)
      // this.realtime = moment().format('MMMM Do YYYY, h:mm:ss a')
      // return moment(value).format('dddd, DD MMMM YYYY')
    },
    onDecode (decodedString) {
      // console.log(decodedString)
      axios.get('fitness/v1/scanning/member_schedule/' + decodedString).then(response => {
        // console.log('test', response.data.data.rows)
        this.iconMessage = 'far fa-check-circle'
        this.messageScan = 'QR Code Scan Successfully'
        this.$toast.success(response.data.message, 'Success', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
      }).catch(error => {
        console.log('error', error)
        this.iconMessage = 'fas fa-exclamation-triangle'
        this.messageScan = 'QR Code Scan Error'
        this.$toast.success('Data member could not be found', 'Error', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
      })
      this.cameraOn = false
      this.scanDone = true
      setTimeout(()=>{
        this.$nextTick(() =>{
          this.scanDone = false
        })
      }, 6000);
    }
  },
  created () {
    // this.realTimeClock()
  }
}
</script>
